<template>
  <div class="plabel" :class="[{ flex: flex }]">
    <span class="plabel-text">
      <i v-if="text" class="el-icon-s-unfold"></i>
      {{ text }}
    </span>
    <span @click="packUpClick" style="margin-left: auto">
      <slot></slot>
    </span>
  </div>
</template>
<script>
export default {
  name: "plabel",
  props: {
    text: {
      type: String,
      default() {
        return "";
      },
    },
    flex: {
      type: Boolean,
      default() {
        return true;
      },
    },
  },
  data() {
    return {};
  },
  methods: {
    packUpClick() {
      this.$emit("click");
    },
  },
};
</script>
<style lang="scss" scoped>
@import "../../style/variables.scss";
.plabel {
  display: block;
  align-items: center;
  font-size: 15px;
  margin: 5px 0 10px 10px;
  .plabel-text {
    color: #333333;
    font-size: 15px;
    line-height: 19px;
    font-weight: normal;
  }
  &.flex {
    display: flex;
  }
}
</style>
